import { getReceiverAccountRemarkHideKeywords } from '@/utils/api'

let hideKeywords = []
let keywordsLoadPromise = null

export function setReceiverAccountRemarkHideKeywords (keywords) {
  hideKeywords = Array.isArray(keywords)
    ? keywords.map(k => String(k).trim()).filter(Boolean)
    : []
}

/** 保证关键词已加载，避免列表先于配置渲染导致短暂露出账号 */
export function ensureReceiverAccountRemarkHideKeywords () {
  if (!keywordsLoadPromise) {
    keywordsLoadPromise = getReceiverAccountRemarkHideKeywords()
      .then((res) => {
        setReceiverAccountRemarkHideKeywords(res?.data || [])
      })
      .catch(() => {
        setReceiverAccountRemarkHideKeywords([])
      })
  }
  return keywordsLoadPromise
}

export function getOrderAccountRemark (item) {
  if (!item) return ''
  return item.withdrawOrder?.receiverAccountRemark
    || item.accountRemark
    || item.receiverAccountRemark
    || ''
}

export function shouldHideAccountNo (item) {
  const remark = getOrderAccountRemark(item)
  if (!remark || hideKeywords.length === 0) return false
  const lower = remark.toLowerCase()
  return hideKeywords.some(k => lower.includes(k.toLowerCase()))
}

/** 命中隐藏时展示备注内容，否则展示账号 */
export function getDisplayAccountNo (item) {
  if (shouldHideAccountNo(item)) {
    return getOrderAccountRemark(item)
  }
  return item?.withdrawOrder?.receiverAccount || item?.receiverAccount || ''
}

/** 接单大厅：命中隐藏时展示 Account Remark，否则 Recipient */
export function getReceiveListRecipientLabel (item) {
  return shouldHideAccountNo(item) ? 'Account Remark' : 'Recipient'
}

export function getReceiveListRecipientDisplay (item) {
  if (shouldHideAccountNo(item)) {
    return getOrderAccountRemark(item)
  }
  return item?.receiverName || ''
}
